import './App.css';
import Layout from './Components/PageLayout/Layout';
import MainContent from './Components/PageLayout/MainContent';
import Summary from './Components/Summary/Summary';
import ToggleLightDarkMode from './Components/Utils/ToggleLightDarkMode';



function App() {


  return (
    <Layout>
      <Summary />
      <MainContent />

    </Layout>
  );
}

export default App;
